import { shouldDispatchGenericError } from './genericErrorDispatch';

export function hasErrors(res, store) {
    if (shouldDispatchGenericError(res, store)) return true;
    return false;
}

const middlewares = { hasErrors };

export default middlewares;
